module.exports = false;


//////////////////
// WEBPACK FOOTER
// /var/www/umem/~/core-js/modules/_library.js
// module id = 31
// module chunks = 0